// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "mapillary" + "-" + "0b3ae3" + ".js";
};